const { triangular, uniform, constant, convoluteMultipleDistributions } = require("./convolution")
const { getExpectedEdgeAbsoluteValues } = require("./payoffs")
import * as d3 from 'd3'

//var chartXaxis = {max: 1, min: -1}

// dnodes.io-colors
const ChartPositive = '#b4d290'
const ChartNegative = '#ffbc98c4'
const BarchartExpected = '#eaeaea'



document.addEventListener("DrawChartsOnCanvases", function(e){
    var {nodes, variables, formatter} = e.detail

    let SCALE = 1
    let chartXaxis = {max: 1, min: -1}
    for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].distribution && nodes[i].charts.some(c => c.active && (c.type == "bar" || c.type == "distribution"))) {
            chartXaxis.max = Math.max(chartXaxis.max, nodes[i].distribution.b)
            chartXaxis.min = Math.min(chartXaxis.min, nodes[i].distribution.a)
        }
        if (!nodes[i].$parent) {
            SCALE = Math.max(getScale(Math.max(...getExpectedEdgeAbsoluteValues(nodes[i], variables))), SCALE)
        }
    }
    
    for (let i = nodes.length -1; i >= 0; i--) {
        let node = nodes[i]
        if (node.charts) {
            for (let j=0; j < node.charts.length; j++){
                if (node.charts[j].active) {
                    var chartType = node.charts[j].type
                    let canvasSize = getCanvasSize(chartType)
                    var canvasId = "#"+chartType+"-"+node.$id
                    var canvas = d3.select(canvasId)
                    if (node.distribution){
                        printChart(canvas, node.distribution, canvasSize, SCALE, node, formatter, chartType, chartXaxis)
                    }
                    else {
                        if (node.type === 'terminal') {
                            const variableList = getListOfVariablesFromTerminalNodeToRoot(node, variables, [], SCALE)
                            const distributions = getListOfDistributions(variableList, SCALE)
                            
                            if (distributions.length > 0) {
                                let distribution = convoluteMultipleDistributions(distributions, SCALE)
                                chartXaxis.max = Math.max(chartXaxis.max, distribution.b)
                                chartXaxis.min = Math.min(chartXaxis.min, distribution.a)
                                printChart(canvas, distribution, canvasSize, SCALE, node, formatter, chartType, chartXaxis)
                            }
                        }
                    
                    }
                }
            }
        }
    }
});

export function getScale(maxEdgeExpectedValue) {
    let maxDeltaX = Math.max(1, maxEdgeExpectedValue)  
    return Math.floor(maxDeltaX/200 +1)
}

export function getListOfVariablesFromTerminalNodeToRoot(node, variables, variableList) {
    
    if (!node.$parent){
        return variableList
    }
    var parent = node.$parent
    var edge = parent.childEdges.find(edge =>  edge.childNode.$id == node.$id && edge)

    var newVariable = getVariableForEdge(edge, variables)
    
    return getListOfVariablesFromTerminalNodeToRoot(parent,variables,variableList.concat(newVariable))
}

export function getVariableForEdge(edge, variables) {
    if (!edge.$fieldStatus.payoff[0].valid.value) {
        return "error" 
    }
    var inputValue = edge.payoff[0]
    if (!isNaN(inputValue)){
        return {value: parseFloat(inputValue), distribution: 'constant'}
    }
    if (inputValue[0] == '-') {
        inputValue = inputValue.substring(1)
        //TODO: flippe verdi? Nå fjernes bare '-'
    }
    var variable = variables.find(v => v.name == inputValue)

    if (variable != undefined) {
        return variable
    } else {
        console.log("Edge value is not valid")
        return "error"
    }

}
export function getListOfDistributions(variables, SCALE) {
    var distributions = []
    for (var i = 0; i < variables.length; i++) {
        distributions.push(getDistributionForVariable(variables[i], SCALE))
    }
    return distributions

}

export function getDistributionForVariable(variable, SCALE){
    // If uniform/triangle values are smaller than the SCALE, convert them into a constant.
    if ((variable.high - variable.low) < SCALE) {   
        if (variable.distribution == 'triangular'){
            return constant(((parseFloat(variable.value)*2) + variable.high + variable.low) / 4)

        } else if (variable.distribution == 'uniform') {
            return constant((variable.high + variable.low) / 2)
        }
    }
    return variable.distribution == 'triangular' ? triangular(variable.low, variable.high, variable.value, SCALE) :
        variable.distribution == 'uniform' ? uniform(variable.low, variable.high, SCALE) :
        constant(parseFloat(variable.value))
}


function printChart(canvas, distribution, canvasSize, SCALE, node, formatter, type, chartXaxis) {
    var maxY = Math.max(...distribution.values)*1.1

    if (!isNaN(node.expectedValue)) {
        
        if (type == "distribution") {
            printDistribution(canvas, canvasSize, maxY, distribution, node, formatter, chartXaxis)
        }
        if (type == "bar") {
            printBarChart(canvas, canvasSize, node, formatter, chartXaxis)
        }
        if (type == "waterfall") {
            printWaterfall(canvas, canvasSize, node, formatter)
        }
        if (type == "tornado") {
            printTornado(canvas, canvasSize, node, formatter)
        }
    }
}

function printWaterfall(canvas, canvasSize, node, formatter) {
    var edges = getListOfParentEdges(node).reverse();
    var expectedValues = edges.map(edge => edge.expectedValue);
    var limits = expectedValues.reduce((sum, val) => {
        return {max: Math.max(sum.curr + val, sum.max), min: Math.min(sum.min, sum.curr + val), curr: sum.curr+val}
    }, {max: 1, min: -1, curr: 0})

    if (!canvas.select('.bar').empty()) {
        canvas.selectAll('.bar').remove()
        canvas.selectAll('.line').remove()
        canvas.selectAll('.values').remove()
    }
    let expectedValueString = formatter[0].format(node.expectedValue)
    let padding = {left: canvasSize.width/10, right: Math.min(canvasSize.width*0.2 + expectedValueString.length*4.8, canvasSize.width*0.8), between: 4, top: 30}
    var scaleY = d3.scaleLinear()
        .domain([limits.max, limits.min])
        .range([30, canvasSize.height-15]);
    
    var lineFunc = d3.line()
        .y(d => scaleY(d[1]))
    canvas.append('path')
        .attr('class', 'line')
        .attr('d', lineFunc([[10, 0], [canvasSize.width-padding.right +10, 0]]))
        .style('stroke', 'grey')
        .style('stroke-width', '1px')

    canvas.append('path')
        .attr('class', 'line')
        .attr('d', lineFunc([[10, node.expectedValue], [canvasSize.width-padding.right +10, node.expectedValue]]))
        .style('stroke', 'lightgrey')
        .style('stroke-width', '1px')

    canvas.append('text')
        .attr('class', 'values')
        .attr('x', canvasSize.width - padding.right + 15)
        .attr('y', scaleY(node.expectedValue) +4)
        .text(expectedValueString)
        .style('font-size', '11px')
        
    let numberOfBars = edges.length
    let barWidth = Math.max(1, ((canvasSize.width - padding.between*numberOfBars - padding.left - padding.right) / (numberOfBars+1)))
    var x = padding.left
    var sum = 0

    for (var i = 0; i < numberOfBars; i++) {
        let edge = edges[i];
        var y = Math.max(sum, sum + edge.expectedValue);
        canvas.append('rect')
            .attr('class', 'bar')
            .attr('x', x)
            .attr('y', scaleY(y))
            .attr('height', Math.max(Math.abs(scaleY(sum) - scaleY(expectedValues[i] + sum)), 0.1))
            .attr('width', barWidth)
            .attr('fill', edge.expectedValue > 0 ? ChartPositive : ChartNegative)
            .attr('opacity', 0.7) 
            .attr('stroke', 'grey')
            .on('mouseover', function(){
                
                d3.select(this)
                    .attr('opacity', 1)

                let nameString = edge.payoff[0];
                let expectedValueString = formatter[0].format(edge.expectedValue);
                let boxWidth = Math.max(60 + nameString.length*6, 38 + expectedValueString.length*6, 35)

                canvas.append('rect')
                    .attr('class', 'waterfall-hover')
                    .attr('x', canvasSize.width-5)
                    .attr('y', padding.top)
                    .attr('fill', 'white')
                    .attr('stroke', 'grey')
                    .attr('height', 35)
                    .attr('width', boxWidth)
                
                canvas.append('text')
                    .attr('class', 'hover-text')
                    .attr('x', canvasSize.width+2)
                    .attr('y', padding.top + 13)
                    .text(nameString + " (payoff)")
                    .style('font-weight', 600)
                    .style('font-size', '11px')

                canvas.append('text')
                    .attr('class', 'hover-text')
                    .attr('x', canvasSize.width+2)
                    .attr('y', padding.top + 29)
                    .text("Exp: " + expectedValueString)
                    .style('font-size', '11px')
            })
            .on('mouseout', function(){
                d3.select(this)
                    .attr('opacity', 0.7)

                canvas.selectAll('.waterfall-hover').remove()
                canvas.selectAll('.hover-text').remove()
            })
                
        sum += edge.expectedValue
        x += barWidth + padding.between
    }
    canvas.append('rect')
            .attr('class', 'bar')
            .attr('x', x)
            .attr('y', scaleY(Math.max(0, sum)))
            .attr('height', Math.abs(scaleY(sum) - scaleY(0)))
            .attr('width', barWidth)
            .attr('fill', BarchartExpected)
            .attr('stroke', 'grey')
}

function getExpectedEdgeValuesFromRoot(node) {
    if (!node.$parent) {
        return []
    }
    let res = []
    let edge = node.$parent.childEdges.find(edge =>  edge.childNode.$id == node.$id && edge)
    res.push(edge)   
    res = res.concat(getExpectedEdgeValuesFromRoot(node.$parent))
    return res
}

function getExpectedOptimalEdgeValuesFromMother(node) {
    if (node.type == 'terminal') {
        return [] 
    }
    let res = []
    for (var i = 0; i< node.childEdges.length; i++ ) {
        let edge = node.childEdges[i]
        if (edge.optimal) {
            res.push(edge)
            res = res.concat(getExpectedOptimalEdgeValuesFromMother(edge.childNode))
        }
    }
    return res
}

function printTornado(canvas, canvasSize, node, formatter) {
    
    if (!canvas.select('.line').empty()) {
        canvas.selectAll('.bar').remove()
        canvas.selectAll('.line').remove()
        canvas.selectAll('.values').remove()
    }
    let edgesInPath
    if (node.type == 'terminal') {
        edgesInPath = getExpectedEdgeValuesFromRoot(node)
    }
    else {
        edgesInPath = getExpectedOptimalEdgeValuesFromMother(node)
    }
    let sortedFirst5Edges = edgesInPath.filter(e => e.p90-e.p10 > 0).sort((a,b) => (b.p90-b.p10) - (a.p90-a.p10)).slice(0,5)
    
    let expectedValue = node.expectedValue
    var limits = sortedFirst5Edges.reduce((lim, node) => {
        return {max: Math.max( expectedValue + node.p90 - node.expectedValue, lim.max), min: Math.min( lim.min, expectedValue-(node.expectedValue-node.p10))}
    }, {max: Math.max(1, expectedValue), min: Math.min(-1, expectedValue)})

    let scaleX = d3.scaleLinear()
        .domain([limits.min, limits.max])
        .range([10, canvasSize.width-10]);

    let lineFunc = d3.line()
        .x(d => scaleX(d[0]))

    let numberOfBars = sortedFirst5Edges.length
    let padding = {bottom: 18, top: 30, between: 8-numberOfBars}

    let barHeight = Math.min(((canvasSize.height - padding.bottom - padding.between*numberOfBars - padding.top - 4) / (numberOfBars)), 20)
    var y = padding.top + 4

    canvas.append('path')
        .attr('class', 'line')
        .attr('d', lineFunc([[expectedValue, padding.top], [expectedValue, canvasSize.height-padding.bottom]]))
        .style('stroke', 'grey')
        .style('stroke-width', '1px')
    
    canvas.append('path')
        .attr('class', 'line')
        .attr('d', lineFunc([[0, padding.top], [0, canvasSize.height-padding.bottom]]))
        .style('stroke', 'lightgrey')
        .style('stroke-width', '1px')

    for (let i = 0; i< sortedFirst5Edges.length; i++) {
        let edge = sortedFirst5Edges[i]

        canvas.append('rect')
            .attr('class', 'bar')
            .attr('x', scaleX(expectedValue - (edge.expectedValue-edge.p10)))
            .attr('y', y)
            .attr('height', barHeight)
            .attr('width', Math.max( scaleX(edge.p90) - scaleX(edge.p10), 0.1))
            .attr('fill', BarchartExpected) 
            .attr('stroke', 'grey')
            .attr('opacity', 0.7)
            .on('mouseover', function(){
                
                d3.select(this)
                    .attr('opacity', 1)
                let nameString = edge.payoff[0].toString()
                let highValueString = formatter[0].format(expectedValue + edge.p90 - edge.expectedValue)
                let lowValueString = formatter[0].format(expectedValue - (edge.expectedValue - edge.p10))
                let boxWidth = Math.max(15 + nameString.length*6, 38 + Math.max(highValueString.length, lowValueString.length)*6, 35)

                canvas.append('rect')
                    .attr('class', 'tornado-hover')
                    .attr('x', canvasSize.width-5)
                    .attr('y', padding.top)
                    .attr('fill', 'white')
                    .attr('stroke', 'grey')
                    .attr('height', 55)
                    .attr('width', boxWidth)
                
                canvas.append('text')
                    .attr('class', 'hover-text')
                    .attr('x', canvasSize.width+2)
                    .attr('y', padding.top + 13)
                    .text(nameString)
                    .style('font-weight', 600)
                    .style('font-size', '11px')

                canvas.append('text')
                    .attr('class', 'hover-text')
                    .attr('x', canvasSize.width+2)
                    .attr('y', padding.top + 29)
                    .text("High: " + highValueString)
                    .style('font-size', '11px')

                canvas.append('text')
                    .attr('class', 'hover-text')
                    .attr('x', canvasSize.width+2)
                    .attr('y', padding.top + 44)
                    .text("Low: " + lowValueString)
                    .style('font-size', '11px')
                
            })
            .on('mouseout', function(){
                d3.select(this)
                    .attr('opacity', 0.7)

                canvas.selectAll('.tornado-hover').remove()
                canvas.selectAll('.hover-text').remove()
                
            })

        y+= barHeight + padding.between
    }

    canvas.append('text')
        .attr('class', 'values')
        .attr('y', padding.top-3)
        .attr('x', scaleX(0) - 4)
        .text("0")
        .style('font-size', '11px')
    
    let expectedValueString = formatter[0].format(expectedValue)
    canvas.append('text')
        .attr('class', 'values')
        .attr("text-anchor", expectedValue > 0 ? "end" : "start")
        .attr('y', canvasSize.height - padding.bottom/3)
        .attr('x', Math.max(Math.min(scaleX(expectedValue) + Math.sign(expectedValue) * expectedValueString.length * 2, canvasSize.width-5), 5))
        .text(expectedValueString)
        .style('font-size', '11px')
   
}

function getListOfParentEdges(node) {
    if (!node.$parent){
        return []
    }
    var parent = node.$parent
    var edge = parent.childEdges.find(edge =>  edge.childNode.$id == node.$id && edge)
    return [edge].concat(getListOfParentEdges(parent))
}

//Set size of charts. Remember to change in app.js. in silverdecisions
function getCanvasSize(type) { 
    return type == "tornado" ? {height: 100, width:150} : {height: 80, width:150}
}

function isPartOfOptimal(node) {
    if (!node.$parent){
        return true
    }
    var parent = node.$parent
    var edge = parent.childEdges.find(edge =>  edge.childNode.$id == node.$id && edge)
    return edge.optimal
}

function printBarChart(canvas, canvasSize, node, formatter, chartXaxis) {
    if (!canvas.select('.bar-chart').empty()) {
        canvas.selectAll('.bar-chart').remove()
        canvas.select('.zero-line').remove()
        canvas.selectAll('.values').remove()
    }

    var barHeight = 15

    var scaleX = d3.scaleLinear()
        .domain([chartXaxis.min*1.1, chartXaxis.max*1.1])
        .range([15, canvasSize.width-15]);

    var zeroAxisFunc = d3.line()
        .x(d => scaleX(d[0]))
    
    canvas.append('rect')
        .attr('class', 'bar-chart')
        .attr('x', scaleX(Math.min(0, node.expectedValue)))
        .attr('y', canvasSize.height/3)
        .attr('width', scaleX(Math.max(0, node.expectedValue)) - scaleX(Math.min(node.expectedValue, 0)))
        .attr('height', barHeight)
        .attr('fill', BarchartExpected)
        .attr('stroke', 'grey')

    let valueString = formatter[0].format(node.expectedValue)
    
    if (isPartOfOptimal(node)){
        let weight = findWeight(node)
        let weightedExp = node.expectedValue * weight
        valueString += " x " + formatter[1].format(weight)
        canvas.append('rect')
            .attr('class', 'bar-chart')
            .attr('x', scaleX(Math.min(0, weightedExp)))
            .attr('y', canvasSize.height/3 +1)
            .attr('width', scaleX(Math.max(0, weightedExp)) - scaleX(Math.min(weightedExp, 0)))
            .attr('height', barHeight-2)
            .attr('fill', weightedExp > 0 ? ChartPositive : ChartNegative)

    }

    canvas.append('text')
        .attr('class', 'values')
        .attr('transform', 'translate(15 65)')
        .text(valueString)
        .style('font-size', '11px')

    canvas.append('path')
        .attr('class', 'zero-line')
        .attr('d', zeroAxisFunc([[0,canvasSize.height/3 - 3], [0, canvasSize.height/3 + barHeight + 3]]))
        .style('stroke', 'grey')
        .style('stroke-width', '1px')

}

function findWeight(node) {
    if (!node.$parent){
        return 1
    }
    var parent = node.$parent
    var edge = parent.childEdges.find(edge =>  edge.childNode.$id == node.$id && edge)
    var edgeWeight = edge.computed.probability ? edge.computed.probability.n/edge.computed.probability.d : 1
    return edgeWeight * findWeight(parent)    
}

function printDistribution(canvas, canvasSize, maxY, distribution, node, formatter, chartXaxis) {
    if (!canvas.select('.graph').empty()) {
        canvas.select('.graph').remove()
        canvas.select('.zero-line').remove()
        canvas.selectAll('.values').remove()
    }

    var scaleX = d3.scaleLinear()
        .domain([chartXaxis.min, chartXaxis.max])
        .range([5, canvasSize.width-5]);
    
    var scaleY = d3.scaleLinear()
        .domain([0, maxY])
        .range([0, (canvasSize.height-15)*0.9]);

    var lineFunc = d3.line()
        .x(function(d) { return scaleX(d.x) })
        .y(function(d) { return canvasSize.height - scaleY(d.y) }) // flip the chart

    var drawableDistribution = convertDistribution(distribution)
    
    canvas.append('path')
        .attr('class', 'graph')
        .attr('d', lineFunc(drawableDistribution))
        .style('stroke', '#2d2d2d')
        .style('stroke-width', '1px')

        .style('fill', node.expectedValue < 0 ? ChartNegative : ChartPositive)
        .style('opacity', '0.2')
    
    var zeroAxisFunc = d3.line()
        .x(d => scaleX(d[0]))

    canvas.append('path')
        .attr('class', 'zero-line')
        .attr('d', zeroAxisFunc([[0,canvasSize.height-1], [0, 20]]))
        .style("stroke-dasharray", "4,4")
        .style('stroke', 'lightgrey')
        .style('stroke-width', '1px')

    var nodeElement = d3.select("g#node-"+node.$id)
    
    if (!nodeElement.select(".new-payoff").empty()) {
        nodeElement.select(".new-payoff").remove()
    }
    let shouldShowPercentiles = node.distribution.values.length > 4 
        && !(node.p10 == 0 && node.p90 == 0 && node.expectedValue == 0)
        && node.p10 < node.expectedValue && node.expectedValue < node.p90


    if (shouldShowPercentiles) {
        canvas.append('text')
            .attr('class', 'values')
            .attr('transform', 'translate(7 30)')
            .text("Low: " + formatter[0].format(node.p10))
            .style('font-size', '11px')
    }
    canvas.append('text')
        .attr('class', 'values')
        .attr('transform', 'translate(7 45)')
        .text("Exp: " + formatter[0].format(node.expectedValue))
        .style('font-weight', '600')
        .style('font-size', '11px')
    
    if (shouldShowPercentiles) {
        canvas.append('text')            
            .attr('class', 'values')
            .attr('transform', 'translate(7 60)')
            .text("High: " + formatter[0].format(node.p90))
            .style('font-size', '11px')
    }
}  


function convertDistribution(distribution) {
    var res = []; 
    res.push({x: distribution.a, y: 0})
    for (var i = 0; i < distribution.values.length; i++){
        var xValue = parseFloat(distribution.a) + (i * distribution.scale)
        res.push({x: xValue, y: distribution.values[i]})
        
    }
    res.push({x: distribution.b, y: 0})
    return res
}


// WEBPACK FOOTER //
// ./scripts/components/showChart.js